import React, { ReactNode, useCallback } from 'react';
import cx from 'clsx';
import { useHistory, useLocation } from 'react-router';

import { IconRcBack } from '@/assets/overview';

import { SearchAddress } from '../SearchAddress';
import { CLEAR_BACK_STATE } from '../DesktopFrame/const';
import style from './index.module.scss';

type Props = {
  className?: string;
  title?: ReactNode;
  hasAddressSearch?: boolean;
  enableBack?: boolean;
  onBackClick?(hasHistory: boolean): void;
  tagName?: string;
  prefix?: ReactNode;
  children?: ReactNode;
};

export const DesktopHeader2 = (props: Props) => {
  const { className, title, hasAddressSearch, onBackClick, enableBack, tagName, prefix, children } =
    props;
  const location = useLocation<typeof CLEAR_BACK_STATE>();
  const history = useHistory();

  const isFromSidebar = location.state?.__clearBack;

  const handleBack = useCallback(() => {
    if (onBackClick) {
      onBackClick(!!location.key);
    } else {
      // 在 app 内
      if (location.key) {
        history.goBack();
      } else {
        history.push('/');
      }
    }
  }, [onBackClick, history, location]);

  return (
    <div className={cx(style.header, className)}>
      <div className={style.headLeft}>
        {prefix}
        {enableBack && !isFromSidebar && location.key ? (
          <div className={style.backBtn} onClick={handleBack}>
            <IconRcBack />
          </div>
        ) : null}
        <span className={style.title}>{title}</span>
        {tagName ? <span className={style.tag}>{tagName}</span> : null}
      </div>
      {hasAddressSearch ? (
        <SearchAddress
          inputClassName={style.headerSearch}
          isShowRecent={false}
          includeOfficialAccount
        />
      ) : null}
      {children}
    </div>
  );
};
